import { ErrorService } from "services/error-service";
import { Router } from "aurelia-router";
import { Models } from "models/core";
import { ImpregnationMethodService } from "services/impregnation-method-service";
import { autoinject } from "aurelia-framework";
import { ToastService } from "services/toast-service";
import { EventAggregator } from "aurelia-event-aggregator";

@autoinject
export class ImpregnationMethodNew {
  private impregnationMethod: Models.ImpregnationMethod = new Models.ImpregnationMethod();

  constructor(
    private impregnationMethodService: ImpregnationMethodService, 
    private router: Router,
    private toastService: ToastService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator
  ) {}

  createImpregnationMethod() {
    this.impregnationMethodService
      .post(this.impregnationMethod)
      .then(res => {
        this.eventAggregator.publish("impregnationMethodListReset", 1);
        this.toastService.showSuccess("impregnationmethod.created");
        this.router.navigateToRoute("impregnation-method-detail", { Id: res.Id });
      })
      .catch(err => this.errorService.handleError(err));
  }
}
